/* ==================================================
   jQuery 3.x 専用スクリプト
   ================================================== */

jq3(function($){

  // DOM Ready（jQuery 3.x）
  console.log('jq3 ready:', $.fn.jquery);

  // 例：クリックイベント
  $('.js-sample').on('click', function(){
    alert('jq3 working');
  });

});
